import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockDeveloperRead } from "../../mock/developer/DeveloperRead";

export const useDeveloperDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetDeveloper = () => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockDeveloperRead());
      } else {
        globalFunctions
          .CallPortalApi("Developer/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetDeveloper };
};
